@use "../../styles/breakpoint.module.scss" as *;

.recipe {
    --grid-column: 3 / span 8;

    composes: fontBody20 from "../../styles/composable/typography.module.css";

    @media ($below-mobile) {
        --grid-column: 1 / -1;
    }
}

.inner {
    padding-top: var(--spacer-32);
}

.title {
    composes: container from "../../styles/composable/layout.module.css";
    composes: fontHeader34 from "../../styles/composable/typography.module.css";
    margin-block: 1em calc(1em + var(--spacer-24));
    text-align: center;
}

/* v2026 */

.heroTitle {
    font: var(--font-h-48);
    color: var(--off-white);
}

.fallbackTitle {
    composes: container from "../../styles/composable/layout.module.css";
    font: var(--font-h-48);
    margin-block: 1em calc(1em + var(--spacer-24));
    text-align: center;
}
